<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="pb-1">Delivery option</div>
        <div class="d-flex flex-row">
          <div class="form-check form-check-inline pr-15">
            <input
              class="form-check-input mr-2"
              id="delivery"
              type="checkbox"
              v-model="form.isAllowDelivery"
              @change="changeDeliveryChk"
            />
            <label class="form-check-label" for="delivery">Delivery</label>
            <div
              v-if="isSubmit && error.errorIsAllowDelivery"
              class="text-error"
            >
              {{ error.errorIsAllowDelivery.message }}
            </div>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input mr-2"
              id="pickup"
              type="checkbox"
              v-model="form.isAllowPickup"
              @change="changePickupChk"
            />

            <label class="form-check-label" for="pickup">Counter pickup</label>
            <div v-if="isSubmit && error.errorIsAllowPickup" class="text-error">
              {{ error.errorIsAllowPickup.message }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="form.isAllowDelivery">
      <div class="row pt-5">
        <div class="label-title">Delivery information</div>
        <div class="col-6">
          <label for="availableQuota">Delivery quota</label>
          <NumberInput v-model.number="form.deliveryQuota" input-id="availableQuota"/>
          <div v-if="isSubmit && error.errorDeliveryQuota" class="text-error">
            {{ error.errorDeliveryQuota.message }}
          </div>
        </div>
        <div class="col-6" v-if="id">
          <label for="remainingQuota">Remaining delivery quota</label>
          <NumberInput v-model.number="form.remainingDeliveryQuota" input-id="remainingQuota" disabled="disabled"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="leadTime">Delivery lead time</label>
          <NumberInput v-model.number="form.deliveryLeadTimeInDay" input-id="leadTime" :is-decimal-allowed="true"/>
          <div
            v-if="isSubmit && error.errorDeliveryLeadTimeInDay"
            class="text-error"
          >
            {{ error.errorDeliveryLeadTimeInDay.message }}
          </div>
        </div>
      </div>
    </div>
    <div v-show="form.isAllowPickup">
      <div class="row pt-5">
        <div class="label-title">Counter pickup information</div>
        <div class="col-6">
          <label for="pickupDateFrom">Pickup date from</label>
          <DatePicker
            id="pickupDateFrom"
            v-bind="$attrs"
            v-model="form.pickupDateFrom"
            format="D MMMM yyyy"
            lang="en"
            :value="form.pickupDateFrom"
            @change="
              changePickupDateFrom($event);
              form.pickupDateFrom = $event;
            "
            style="margin-top: -0.6rem"
          />
          <div v-if="isSubmit && error.errorPickupDateFrom" class="text-error">
            {{ error.errorPickupDateFrom.message }}
          </div>
        </div>
        <div class="col-6">
          <label for="pickupDateTo">Pickup date to</label>
          <DatePicker
            id="pickupDateTo"
            v-bind="$attrs"
            v-model="form.pickupDateTo"
            format="D MMMM yyyy"
            lang="en"
            :value="form.pickupDateTo"
            :minDate="form.pickupDateFrom"
            @change="form.pickupDateTo = $event"
            style="margin-top: -0.6rem"
          />
          <div v-if="isSubmit && error.errorPickupDateTo" class="text-error">
            {{ error.errorPickupDateTo.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <a
            href="#"
            target="_blank"
            class="download-sample-file-link"
            @click.prevent="downloadSampleFile"
            >Download sample file</a
          >
          <div class="d-flex align-items-center justify-content-around gap-3">
            <input
              type="file"
              class="form-control my-2"
              @change="uploadSampleProductFile"
              :disabled="isFileLoading"
            />
            <FileLoading v-if="isFileLoading" />
          </div>
          <div
            v-if="isSubmit && error.errorPickupCountersWithQuotaTempFile"
            class="text-error"
          >
            {{ error.errorPickupCountersWithQuotaTempFile.message }}
          </div>
          <a
            v-if="form.currentPickupCountersWithQuotaFile"
            href="#"
            target="_blank"
            class="trigger"
            @click.prevent="downloadCurrentFile"
            >Download</a
          >
        </div>
      </div>
      <div>
        <ListSamplePickupStores
          :items="listSamplePickupStores"
          :show-warning-message="showWarningMessage"
          v-if="listSamplePickupStores.length > 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "components/Datepicker/Datepicker.vue";
import FileLoading from "components/Loading/FileLoading.vue";
import NumberInput from "components/NumberInput/NumberInput.vue";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import ListSamplePickupStores from "@/views/Privilege/ListSamplePickupStores.vue";

export default {
  name: "SampleProductDeliveryOption",
  components: {NumberInput, FileLoading, ListSamplePickupStores, DatePicker },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    listSamplePickupStores: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFileLoading: false,
      showWarningMessage: false,
      id: this.$route.query.id,
    };
  },
  methods: {
    changePickupDateFrom(val) {
      if (val > this.form.pickupDateTo) {
        this.form.pickupDateTo = null;
      }
    },
    changeDeliveryChk() {
      if (!this.form.isAllowDelivery) {
        this.form.deliveryQuota = null;
        this.form.deliveryLeadTimeInDay = null;
      }
    },
    changePickupChk() {
      if (!this.form.isAllowPickup) {
        this.form.pickupCountersWithQuotaTempFile = null;
        this.form.pickupDateFrom = null;
        this.form.pickupDateTo = null;
      }
    },
    uploadSampleProductFile(e) {
      if (e.target.files) {
        const file = e.target.files[0];
        this.getPresignURL(file);
      }
    },
    async getPresignURL(file) {
      this.isFileLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("sampleProduct", file)
        .then((res) => {
          const data = res.data;
          this.form.pickupCountersWithQuotaTempFile = data.key;
          this.updatePhotoToS3(data.presignedUrl, file);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isFileLoading = false;
      this.showWarningMessage = true;
    },
    downloadSampleFile() {
      try {
        window.open(
          process.env.VUE_APP_HOST_API +
            "static/sample/samplePickupCountersQuota.xlsx"
        );
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    downloadCurrentFile() {
      try {
        window.open(this.form.currentPickupCountersWithQuotaFile);
      } catch (error) {
        console.log("Error: ", error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label-title {
  font-weight: 900;
}

.download-sample-file-link {
  color: #6e6e6e;
}
</style>
